module.exports = __webpack_public_path__ + "img/praxispay.9f7dfeab.svg";